<template>
  <v-card style="box-shadow: none" >
    <v-toolbar flat id='manageTable'>
      <v-toolbar-title class='display-1 fontcolor'>{{
        TABLE_TITLE
      }}</v-toolbar-title>
      <v-spacer></v-spacer>
    </v-toolbar>
    <template >
      <div class="mt-1" style="box-shadow: 0px 1px 3px rgba(9, 35, 58, 0.16);">
        <v-card-title class='body-1 fontcolor'>{{SEARCH_JURISDICTION}}</v-card-title>
        <v-row class="ml-2 mr-2 mb-8 mt-2">
        <v-col class="d-flex" cols="4" lg="4" sm="3" >
          <v-autocomplete
          class="caption"
          v-model="filterItem.countryId"
            :items='countryList'
            item-text='name'
            item-value='id'
            label="Country"
            dense
            @change="filterState"
            :loading="loadingCountry"
          ></v-autocomplete>
        </v-col>
        <v-col class="d-flex" cols="4" lg="4" sm="3" >
          <v-autocomplete
          class="caption"
          v-model="filterItem.stateId"
            :items='stateList'
            item-text='name'
            item-value='id'
            label="State"
            @change="filterCounty"
            :loading="loadingState"
            dense
          ></v-autocomplete>
        </v-col>
        <v-col class="d-flex" cols="4" lg="4" sm="3">
          <v-autocomplete
          class="caption"
          v-model="filterItem.countyId"
            :items='countyList'
            label="County"
            :item-text='customCountyName'
            item-value='id'
            dense
            :loading="loadingCounty"
          ></v-autocomplete>
        </v-col>
        <v-col class="d-flex" cols="4" lg="4" sm="3">
          <v-autocomplete
          class="caption"
          @keyup="onTextSearch"
          v-model="filterItem.jurisdictionId"
          :items='jurisdictions'
          label="Jurisdiction"
          placeholder="Enter jurisdiction name"
          :item-text='customJurisdictionName'
          item-value='id'
          :loading="loadingJurisdiction"
          dense
          ></v-autocomplete>
        </v-col>
        <v-col class="d-flex" cols="4" lg="4" sm="3">
          <v-autocomplete
          class="caption"
          v-model="filterItem.fipsId"
            :items='fipsList'
            label="FIPS"
            item-text='name'
            item-value='id'
            dense
            :loading="loadingFips"
          ></v-autocomplete>
        </v-col>
        <v-col class="d-flex" cols="4" lg="4" sm="3">
          <v-autocomplete
          class="caption"
          v-model="filterItem.fstatus"
            :items='defaultStatusItems'
            label="Status"
            item-text='name'
            item-value='statusFieldId'
            dense
            :loading="loadingFips"
          ></v-autocomplete>
        </v-col>
        <v-col style="text-align:right !important" class="text-lg-right pa-0 mt-n4" cols="12">
          <v-tooltip top>
            <template v-slot:activator="{ on }">
              <v-btn v-on="on" text small class='mr-2 text-lg-right text-capitalize' @click="onReset">Reset</v-btn>
            </template>
            <span>Reset</span>
          </v-tooltip>
          <v-tooltip top>
            <template v-slot:activator="{ on }">
              <v-btn  v-on="on" outlined dark class='mb-2 fontcolor mr-2 text-lg-right' color="success" @click="onSearch"><v-icon>mdi-magnify</v-icon> Search</v-btn>
            </template>
            <span>Search</span>
          </v-tooltip>
        </v-col>
        <v-spacer></v-spacer>
      </v-row>
      </div>
    </template>
    <v-data-table
      :loading='loading'
      :headers='headers'
      :items='paginatedJurisdictionList'
      class='elevation-1'
      :page.sync="page"
      :options.sync= "options"
      :server-items-length="totalJurisdictions"
      :items-per-page="itemsPerPage"
      :footer-props="{'items-per-page-options': rowsPerPageItems
        }"
    >
      <template v-slot:top>
        <v-toolbar flat id='manageTable'>
          <v-dialog default v-model='addDialog'>
            <template v-slot:activator='{ on }'>
              <v-spacer></v-spacer>
              <v-btn
                outlined
                class='mb-2 fontcolor'
                v-on='on'
              >
                <v-icon >mdi-plus</v-icon>
                {{ ADD_NEW_JURISDICTION }}
              </v-btn>
            </template>
            <template>
              <add-jurisdiction
              @resetDialog='addDialog = $event'
              :userId='userId'
              :addDialogProp = 'addDialog'
              @resetAddTotalAdoptions='totalJurisdictions = $event'
              ></add-jurisdiction>
            </template>
          </v-dialog>
        </v-toolbar>
      </template>
      <template v-slot:item.action='{ item }'>
        <v-tooltip top>
          <template v-slot:activator="{ on }">
            <v-icon v-on="on" text small class='mr-2' @click='editItem(item,1)'>mdi-eye</v-icon>
          </template>
          <span>View Adoptions</span>
        </v-tooltip>
        <v-tooltip top>
          <template v-slot:activator="{ on }">
            <v-icon v-on="on" text small class='mr-2' @click="bulkEditUrl(item, '3')" >mdi-format-list-checks</v-icon>
          </template>
          <span>Manage Bulk Adoption</span>
        </v-tooltip>
        <v-tooltip top>
          <template v-slot:activator="{ on }">
            <v-icon v-on="on" text small class='mr-2' @click='editItem(item,3)'>mdi-border-color</v-icon>
          </template>
          <span>Edit Profile</span>
        </v-tooltip>
        <v-tooltip top>
          <template v-slot:activator="{ on }">
            <v-icon v-if="item.status === 1" v-on="on" text small class='mr-2' @click='validateDeleteJuridictionItem(item)'>mdi-delete</v-icon>
          </template>
          <span>Delete Jurisdiction</span>
        </v-tooltip>
        <v-tooltip top>
          <template v-slot:activator="{ on }">
            <v-icon v-on="on" text small class='mr-2' @click='goToPublicProfileUrlFromAdmin(3, item.stateName, item.name)' >mdi-launch</v-icon>
          </template>
          <span>End User View</span>
        </v-tooltip>
      </template>
      <template v-slot:no-data>
        <p>{{ NO_DATA_FOUND }}</p>
      </template>
      </v-data-table>
      <ConfirmationBox  :dialog="deleteDialog" :heading="heading" :discription="dialogDiscription" :cancel="cancel" :confirm="confirmDelete" :btnLoaderConfirm="btnLoaderConfirm" />
      <AlertBox :alertDialog="alertDialog"  :discription="alertDiscription" :cancel="closeAlertBox" />
  </v-card>
</template>

<script>
import CONSTANTS from './../../../../config/constant'
import AddJurisdiction from './ManageAddJurisdiction'
import { _ } from 'vue-underscore'

export default {
  name: 'AdminJurisdictions',
  components: {
    'add-jurisdiction': AddJurisdiction,
    ConfirmationBox: () => import('./dialog.vue'),
    AlertBox: () => import('./alert.vue')
  },
  data: () => ({
    keyCode: [37, 38, 39, 40],
    search: '',
    NO_DATA_FOUND: CONSTANTS.NO_DATA_FOUND,
    TABLE_TITLE: CONSTANTS.MANAGE_JURISDICTION,
    ADD_NEW_JURISDICTION: CONSTANTS.ADD_NEW_JURISDICTION,
    SEARCH_JURISDICTION: CONSTANTS.SEARCH_JURISDICTION,
    loading: true,
    loadingCountry: true,
    loadingState: true,
    loadingCounty: true,
    loadingFips: true,
    loadingJurisdiction: false,
    addDialog: false,
    editedIndex: -1,
    btnLoader: false,
    rowsPerPageItems: [5, 10, 20, 50, 100],
    options: {},
    tempJurisdictionList: [],
    tempCounty: [],
    page: 1,
    totalJurisdictions: 0,
    itemsPerPage: 10,
    queryParams: '',
    deleteDialog: false,
    alertDialog: false,
    btnLoaderConfirm: false,
    dialogDiscription: '',
    alertDiscription: '',
    deleteIndex: -1,
    heading: 'Jurisdiction',
    filterItem: {
      id: '',
      stateId: '',
      jurisdictionId: '',
      fipsId: '',
      countryId: '',
      countyId: '',
      fstatus: ''
    },
    defaultItem: {
      id: '',
      stateId: '',
      jurisdictionId: '',
      fipsId: '',
      countryId: '',
      countyId: '',
      fstatus: ''
    },
    defaultStatus: CONSTANTS.DEFAULT_RECORDS_STATUS,
    statusValues: CONSTANTS.DEFAULT_RECORDS_STATUS_VALUE,
    defaultStatusItems: CONSTANTS.RECORDS_STATUS,
    statusItems: [
      { statusText: 'Inactive', statusVal: 1 },
      { statusText: 'Published', statusVal: 2 }
    ],
    headers: [
      {
        text: 'ID',
        sortable: true,
        align: 'left',
        value: 'id',
        class: 'subtitle-2 primaryColor'
      },
      {
        text: 'Jurisdiction Name',
        sortable: true,
        value: 'name',
        class: 'subtitle-2 primaryColor'
      },
      {
        text: 'FIPS',
        value: 'fipValue',
        sortable: false,
        class: 'subtitle-2 primaryColor'
      },
      {
        text: 'Country',
        value: 'countryName',
        sortable: false,
        class: 'subtitle-2 primaryColor'
      },
      {
        text: 'State',
        value: 'stateName',
        sortable: false,
        class: 'subtitle-2 primaryColor'
      },
      {
        text: 'County',
        value: 'countyName',
        sortable: false,
        class: 'subtitle-2 primaryColor'
      },
      {
        text: 'Status',
        value: 'statusText',
        sortable: true,
        class: 'subtitle-2 primaryColor'
      },
      { text: 'Actions', value: 'action', sortable: false, class: 'subtitle-2 primaryColor' }
    ]
  }),
  mounted () {
    this.onTextSearch = _.debounce(this.onTextSearch, 350)
    this.initialize()
  },
  watch: {
    options: {
      handler () {
        const formData = {
          id: this.filterItem.id === undefined ? '' : this.filterItem.id,
          stateId: this.filterItem.stateId === undefined ? '' : this.filterItem.stateId,
          countryId: this.filterItem.countryId === undefined ? '' : this.filterItem.countryId,
          jurisdictionId: this.filterItem.jurisdictionId === undefined ? '' : this.filterItem.jurisdictionId,
          fipsId: this.filterItem.fipsId === undefined ? '' : this.filterItem.fipsId,
          fCounty: this.filterItem.countyId === undefined ? '' : this.filterItem.countyId,
          fStatus: this.filterItem.fstatus === undefined ? '' : this.filterItem.fstatus
        }
        const { sortBy, sortDesc, page, itemsPerPage } = this.options
        const { stateId, countryId, jurisdictionId, fipsId, fCounty, fStatus } = formData
        let fs = ''
        if (fStatus === 'Inactive') {
          fs = 1
        }
        if (fStatus === 'Published') {
          fs = 2
        }
        let sortOrder = sortDesc[0] === true ? 'asc' : 'desc'
        if (sortBy.length === 1 || sortDesc.length === 1 || page !== 1 || itemsPerPage) {
          this.queryParams = `?page=${page}&itemsPerPage=${itemsPerPage}&sortBy=${sortBy}&direction=${sortOrder}&fCountry=${countryId}&fState=${stateId}&fJurisdiction=${jurisdictionId}&fFips=${fipsId}&fCounty=${fCounty}&fStatus=${fs}`
        }
        this.$store.commit('JurisdictionModule/addQueryParams', this.queryParams)
        new Promise((resolve, reject) => {
          this.$store.dispatch('JurisdictionModule/getPaginatedJurisdictionList', {
            resolve,
            reject
          })
        })
          .then(responseData => {
            this.totalJurisdictions = responseData.pagination.totalRecords
            this.loading = false
          })
          .catch(response => {
          })
      },
      deep: true
    }
  },
  computed: {
    // to fetch jurisdiction list
    jurisdictions () {
      return this.tempJurisdictionList.list // this.$store.getters['JurisdictionModule/fetchJurisdictionList']
    },
    paginatedJurisdictionList () {
      return this.$store.getters['JurisdictionModule/fetchPaginatedJurisdictionList']
    },
    // to get logged in user ID
    userId () {
      return this.$store.getters['AuthModule/getUserId']
    },
    editDialog () {
      return this.$store.getters['JurisdictionModule/fetchEditDialog']
    },
    stateList () {
      return this.$store.getters['StateModule/fetchStateList']
    },
    countyList () {
      return this.$store.getters['CountyModule/fetchCountyList']
    },
    countryList () {
      let cList = this.$store.getters['CountryModule/fetchCountryList']
      if (Object.keys(cList).length !== 0) {
        let newCList = this.$globalStates.makeUSAAsFirstItem(cList)
        return newCList
      } else {
        return cList
      }
    },
    fipsList () {
      return this.$store.getters['JurisdictionModule/fetchFIPSList']
    }
  },
  methods: {
    customCountyName: item => item.name + ', ' + item.stateAbbr,
    customJurisdictionName: item => item.name + ', ' + item.stateAbbr,
    searchJurisdition (formData) {
      new Promise((resolve, reject) => {
        this.$store.dispatch('JurisdictionModule/textJurisdictionSearch', {
          resolve,
          reject,
          formData
        })
      })
        .then(responseData => {
          this.tempJurisdictionList = responseData
        // add loader on button if required
        })
        .catch(response => {
          this.tempJurisdictionList = []
          // add loader on button if required
        })
    },
    onTextSearch (event) {
      let fetchOnlyPublished = CONSTANTS.DEFAULT_RECORDS_STATUS_VALUE.Published
      const keyCode = this.keyCode
      const searchString = event.target.value
      const formData = {
        searchString: searchString,
        countyId: this.filterItem.countyId,
        stateId: this.filterItem.stateId,
        countryId: this.filterItem.countryId,
        status: fetchOnlyPublished
      }
      if (searchString.length >= 3) {
        if (!keyCode.includes(event.keyCode)) {
          this.searchJurisdition(formData)
        }
      } else {
        this.tempJurisdictionList = []
      }
    },
    filterState () {
      let fetchOnlyPublished = CONSTANTS.DEFAULT_RECORDS_STATUS_VALUE.Published
      // const stateId = this.filterItem.stateId
      const countryId = this.filterItem.countryId
      new Promise((resolve, reject) => {
        this.$store.dispatch('StateModule/getStateList', {
          resolve,
          reject,
          countryId,
          fetchOnlyPublished
        })
      })
        .then(responseData => {
          this.loadingState = false
        })
        .catch(response => {
          this.loadingState = false
        })
      new Promise((resolve, reject) => {
        this.$store.dispatch('CountyModule/getCountyList', {
          resolve,
          reject,
          countryId,
          fetchOnlyPublished
        })
      })
        .then(responseData => {
          this.tempCounty = responseData
          // add loader on button if required
        }
        )
        .catch(response => {
          this.tempCounty = []
          // add loader on button if required
        })
      // reset jurisdiction dropdown
      this.tempJurisdictionList = []
    },
    // filter county on based on state selected
    filterCounty () {
      let fetchOnlyPublished = CONSTANTS.DEFAULT_RECORDS_STATUS_VALUE.Published
      const stateId = this.filterItem.stateId
      const countryId = this.filterItem.countryId
      new Promise((resolve, reject) => {
        this.$store.dispatch('CountyModule/getCountyList', {
          resolve,
          reject,
          countryId,
          stateId,
          fetchOnlyPublished
        })
      })
        .then(responseData => {
          this.tempCounty = responseData
          // add loader on button if required
        }
        )
        .catch(response => {
          this.tempCounty = []
          // add loader on button if required
        })
      // reset jurisdiction dropdown
      this.tempJurisdictionList = []
    },
    onReset () {
      Object.assign(this.filterItem, this.defaultItem)
      let fetchOnlyPublished = CONSTANTS.DEFAULT_RECORDS_STATUS_VALUE.Published
      const { sortBy, sortDesc, page, itemsPerPage } = this.options
      if (sortBy.length === 1 || sortDesc.length === 1 || page !== 1 || itemsPerPage) {
        let sb = typeof (sortBy[0]) !== 'undefined' ? sortBy[0] : ''
        let sortOrder = sortDesc[0] === true ? 'asc' : 'desc'

        this.queryParams = `?page=${page}&itemsPerPage=${itemsPerPage}&sortBy=${sb}&direction=${sortOrder}`
      }
      this.$store.commit('JurisdictionModule/addQueryParams', this.queryParams)
      new Promise((resolve, reject) => {
        this.$store.dispatch('JurisdictionModule/getPaginatedJurisdictionList', {
          resolve,
          reject
        })
      })
        .then(responseData => {
          this.totalJurisdictions = responseData.pagination.totalRecords
          this.loading = false
        })
        .catch(response => {
          this.loading = false
        })
      new Promise((resolve, reject) => {
        this.$store.dispatch('CountyModule/getCountyList', {
          resolve,
          reject,
          fetchOnlyPublished
        })
      })
        .then(responseData => {
          this.loadingCounty = false
        })
        .catch(response => {
          this.loadingCounty = false
        })
      this.tempJurisdictionList = []
      new Promise((resolve, reject) => {
        this.$store.dispatch('CountryModule/getCountryList', { resolve, reject, fetchOnlyPublished })
      }).then(responseData => {
        this.loadingCountry = false
      }).catch(response => {
        this.loadingCountry = false
      })
      new Promise((resolve, reject) => {
        this.$store.dispatch('StateModule/getStateList', {
          resolve,
          reject,
          fetchOnlyPublished
        })
      })
        .then(responseData => {
          this.isEditingCounty = false
          this.loadingState = false
        })
        .catch(response => {
          this.isEditingCounty = false
          this.isEditingState = false
          this.loadingState = false
        })
    },
    initialize () {
      Object.assign(this.filterItem, this.defaultItem)
      const { sortBy, sortDesc, page, itemsPerPage } = this.options
      let sortOrder = sortDesc[0] === true ? 'asc' : 'desc'
      if (sortBy.length === 1 || sortDesc.length === 1 || page !== 1 || itemsPerPage) {
        this.queryParams = `?page=${page}&itemsPerPage=${itemsPerPage}&sortBy=${this.sortBy}&direction=${sortOrder}`
      }
      this.$store.commit('JurisdictionModule/addQueryParams', this.queryParams)
      let fetchOnlyPublished = CONSTANTS.DEFAULT_RECORDS_STATUS_VALUE.Published
      let countryId = ''
      let stateId = ''
      new Promise((resolve, reject) => {
        this.$store.dispatch('JurisdictionModule/getPaginatedJurisdictionList', {
          resolve,
          reject
        })
      })
        .then(responseData => {
          this.totalJurisdictions = responseData.pagination.totalRecords
          this.loading = false
        })
        .catch(response => {
          this.loading = false
        })
      new Promise((resolve, reject) => {
        this.$store.dispatch('CountryModule/getCountryList', { resolve, reject, fetchOnlyPublished })
      }).then(responseData => {
        this.loadingCountry = false
      }).catch(response => {
        this.loadingCountry = false
      })
      new Promise((resolve, reject) => {
        this.$store.dispatch('StateModule/getStateList', {
          resolve,
          reject,
          countryId,
          fetchOnlyPublished
        })
      })
        .then(responseData => {
          this.isEditingCounty = false
          this.loadingState = false
        })
        .catch(response => {
          this.isEditingCounty = false
          this.isEditingState = false
          this.loadingState = false
        })
      new Promise((resolve, reject) => {
        this.$store.dispatch('CountyModule/getCountyList', {
          resolve,
          reject,
          countryId,
          stateId,
          fetchOnlyPublished
        })
      })
        .then(responseData => {
          // add loader on button if required
          this.loadingCounty = false
        })
        .catch(response => {
          this.isEditingCounty = false
          this.loadingCounty = false
          // add loader on button if required
        })
      const status = CONSTANTS.DEFAULT_RECORDS_STATUS_VALUE.Published
      new Promise((resolve, reject) => {
        this.$store.dispatch('AdoptionProfileModule/getAdoptionProfileList', {
          resolve,
          reject,
          status
        })
      })
        .then(responseData => {
          // add loader on button if required
        })
        .catch(response => {
          // add loader on button if required
        })
      new Promise((resolve, reject) => {
        this.$store.dispatch('PostalCodeModule/getPostalCodeList', {
          resolve,
          reject,
          status
        })
      })
        .then(responseData => {
          // add loader on button if required
        })
        .catch(response => {
          // add loader on button if required
        })
      new Promise((resolve, reject) => {
        this.$store.dispatch('JurisdictionModule/getFIPSList', {
          resolve,
          reject
        })
      })
        .then(responseData => {
          this.loadingFips = false
        })
        .catch(response => {
          this.loadingFips = false
        })
    },
    editItem (county, navId) {
      // route push to edit page
      if (navId === 3) {
        this.$router.push({ name: 'AdminEditJurisdiction', params: { id: county.id, tabId: 3 } })
      }
      if (navId === 1) {
        this.$router.push({ name: 'AdminEditJurisdiction', params: { id: county.id, tabId: 1 } })
      }
    },
    bulkEditUrl (id, adoptionLevel) {
      this.$router.push({ name: 'BulkAdoption', params: { adoptionLevel: CONSTANTS.BULK_ADOPTION_URL[adoptionLevel], id: id.id } })
    },
    goToPublicProfileUrlFromAdmin (adoptionLevel, sName, jName) {
      let stateName = ''
      let jurisdictionName = ''
      if (sName !== '' && sName !== undefined) {
        stateName = sName.replace(/\s+/g, '-')
      }
      if (jName !== '' && jName !== undefined) {
        jurisdictionName = jName.replace(/\s+/g, '-')
      }
      switch (adoptionLevel) {
        case 3:
          let routeData = this.$router.resolve({ name: 'JurisdictionCodeAdoption', params: { stateName: stateName, jurisdictionName: jurisdictionName } })
          window.open(routeData.href, '_blank')
          break
      }
    },
    onSearch () {
      const formData = {
        stateId: this.filterItem.stateId === undefined ? '' : this.filterItem.stateId,
        countryId: this.filterItem.countryId === undefined ? '' : this.filterItem.countryId,
        jurisdictionId: this.filterItem.jurisdictionId === undefined ? '' : this.filterItem.jurisdictionId,
        fipsId: this.filterItem.fipsId === undefined ? '' : this.filterItem.fipsId,
        fCounty: this.filterItem.countyId === undefined ? '' : this.filterItem.countyId,
        fStatus: this.filterItem.fstatus === undefined ? '' : this.filterItem.fstatus
      }
      const { sortBy, sortDesc, itemsPerPage } = this.options
      const page = 1
      const { stateId, countryId, jurisdictionId, fipsId, fCounty, fStatus } = formData
      let fs = ''
      if (fStatus === 'Inactive') {
        fs = 1
      }
      if (fStatus === 'Published') {
        fs = 2
      }
      let sortOrder = sortDesc[0] === true ? 'asc' : 'desc'
      if (sortBy.length === 1 || sortDesc.length === 1 || itemsPerPage) {
        this.queryParams = `?page=${page}&itemsPerPage=${itemsPerPage}&sortBy=${sortBy}&direction=${sortOrder}&fCountry=${countryId}&fState=${stateId}&fFips=${fipsId}&fJurisdiction=${jurisdictionId}&fCounty=${fCounty}&fStatus=${fs}`
      }
      this.$store.commit('JurisdictionModule/addQueryParams', this.queryParams)
      new Promise((resolve, reject) => {
        this.$store.dispatch('JurisdictionModule/getPaginatedJurisdictionList', {
          resolve,
          reject
        })
      })
        .then(responseData => {
          this.totalJurisdictions = responseData.pagination.totalRecords
          this.loading = false
        })
        .catch(response => {
        })
    },
    validateDeleteJuridictionItem (jurisdiction) {
      let formData = {
        userId: this.userId,
        id: jurisdiction.id,
        isValidation: true
      }
      this.deleteIndex = formData.id
      new Promise((resolve, reject) => {
        this.$store.dispatch('JurisdictionModule/validateJuridictionDeleteItem', { resolve, reject, formData })
      }).then((responseData) => {
        this.deleteDialog = true
        this.dialogDiscription = `'` + jurisdiction.name + `'`
      }).catch((response) => {
        this.alertDialog = true
        this.alertDiscription = response.responseMessage.split('.').join(' ') + ' ' + `'` + jurisdiction.name + `'` + ' Jurisdiction.'
      })
    },
    confirmDelete () {
      this.btnLoaderConfirm = true
      const formData = { userId: this.userId, id: this.deleteIndex }
      let isPromise = new Promise((resolve, reject) => {
        this.$store.dispatch('JurisdictionModule/deleteJuridictionItem', { resolve, reject, formData })
      })
      isPromise
        .then((response) => {
          this.deleteIndex = -1
          this.deleteDialog = false
          this.btnLoaderConfirm = false
          this.$globalStates.notification.type = 'green'
          this.$globalStates.notification.text = response.responseMessage
          this.$globalStates.notification.init_notifications = true
        })
        .catch((response) => {
          this.deleteIndex = -1
          this.deleteDialog = false
          this.$globalStates.notification.type = 'error'
          this.$globalStates.notification.text = response.responseMessage
          this.$globalStates.notification.init_notifications = true
        })
    },
    cancel () {
      this.deleteDialog = false
    },
    closeAlertBox () {
      this.alertDialog = false
    }
  }
}
</script>
